function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M355.172,0.715c-6.659,0.478-13.134,0.909-19.417,1.287c-28.171,1.709-48.54,2.568-61.099,2.568 c-6.472,0-13.422-0.193-20.842-0.571L163.312,0l-5.426,29.408c1.902,0.378,5.52,0.762,10.85,1.143 c19.602,1.138,33.308,3.806,41.112,7.993v10.85l-2.284,14.272l-6.28,38.544l-4.57,17.988l-8.28,44.824c0,0.193-0.334,1.288-1,3.287 c-0.666,1.997-1.524,4.899-2.568,8.705c-1.049,3.809-2.236,8.235-3.571,13.278c-1.335,5.042-2.856,11.421-4.57,19.13 c-1.713,7.707-3.332,15.751-4.853,24.124l-3.428,18.274l-15.986,76.517l-7.71,39.677c-2.285,12.189-6.184,21.802-11.704,28.838 c-7.614,3.81-18.654,7.519-33.12,11.14c-13.894,3.613-21.221,5.517-21.982,5.708l-4.853,24.273 c4.565-0.38,13.891-1.235,27.978-2.573c25.315-2.283,41.874-3.33,49.676-3.139l56.532,0.568 c23.979,2.478,37.777,4.093,41.391,4.859c3.617,0.568,6.283,0.855,7.994,0.855c3.429,0,7.423-0.191,11.991-0.571 c0.951-0.188,3.142-0.284,6.567-0.284c0.38-1.902,1.235-5.808,2.569-11.711c1.137-5.52,1.804-11.039,1.999-16.562 c-5.715-0.948-11.991-1.903-18.85-2.848c-10.461-1.143-21.792-3.145-33.975-5.996c-0.564-3.805-0.661-6.375-0.281-7.71l3.43-12.847 l12.278-67.091l10.849-45.111l17.418-88.793c4.183-20.367,10.466-49.484,18.847-87.366c0.763-7.232,1.995-15.037,3.713-23.413 c2.282-10.848,4.571-19.221,6.851-25.125c7.043-2.853,16.659-5.802,28.836-8.848c10.286-2.281,20.655-5.232,31.121-8.848 c1.146-4.188,2.389-9.041,3.716-14.561c0.767-3.619,1.335-7.233,1.711-10.848C365.261,0.003,361.832,0.24,355.172,0.715z"
}));

var _ref3 = /*#__PURE__*/React.createElement("g", null);

var _ref4 = /*#__PURE__*/React.createElement("g", null);

var _ref5 = /*#__PURE__*/React.createElement("g", null);

var _ref6 = /*#__PURE__*/React.createElement("g", null);

var _ref7 = /*#__PURE__*/React.createElement("g", null);

var _ref8 = /*#__PURE__*/React.createElement("g", null);

var _ref9 = /*#__PURE__*/React.createElement("g", null);

var _ref10 = /*#__PURE__*/React.createElement("g", null);

var _ref11 = /*#__PURE__*/React.createElement("g", null);

var _ref12 = /*#__PURE__*/React.createElement("g", null);

var _ref13 = /*#__PURE__*/React.createElement("g", null);

var _ref14 = /*#__PURE__*/React.createElement("g", null);

var _ref15 = /*#__PURE__*/React.createElement("g", null);

var _ref16 = /*#__PURE__*/React.createElement("g", null);

var _ref17 = /*#__PURE__*/React.createElement("g", null);

var SvgItalic = function SvgItalic(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    x: "0px",
    y: "0px",
    width: "15px",
    height: "15px",
    viewBox: "0 0 438.543 438.543",
    style: {
      enableBackground: "new 0 0 438.543 438.543"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgItalic, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/italic.08a84008.svg";
export { ForwardRef as ReactComponent };